import { useDispatch, useSelector } from "react-redux";
import { getAddonId } from 'h-commons';

import { trialFeaturesSelector } from "../../sharedmailbox/common/TrialAddon/redux/selector";
import { startTrialActionCreator } from "../../sharedmailbox/common/TrialAddon/redux/actionCreator";
import { fetchUserDetails } from "../../main/actions";

export const useStartTrialAddOn = () => {
    const dispatch = useDispatch();
    const addonsAvailable = useSelector(trialFeaturesSelector);

    const startAddonTrial = (ugId, addon_key) => {
        return new Promise((resolve, reject) => {
            const addonId = getAddonId(addonsAvailable, addon_key);

            dispatch(startTrialActionCreator({ userGroupId: ugId, addonId }))
                .then(() => {
                    // Refresh account data to reflect newly available features
                    dispatch(fetchUserDetails());
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };
    return { startAddonTrial };
}
